import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import {
    Box,
    TextField,
    Typography,
    InputAdornment
} from '@mui/material';

const FinancialInfoSection = () => {
    const { control, formState: { errors } } = useFormContext();

    const formatCurrency = (value) => {
        if (!value) return '';
        // Remove non-numeric characters except decimal point
        const numericValue = value.toString().replace(/[^\d.]/g, '');
        const parts = numericValue.split('.');
        // Format the integer part with commas
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        // Limit decimal places to 2
        if (parts[1]) {
            parts[1] = parts[1].substring(0, 2);
        }
        return parts.join('.');
    };

    const parseCurrency = (value) => {
        if (!value) return '';
        // Remove commas and return the numeric value
        return value.replace(/,/g, '');
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Financial Information
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Controller
                    name="monthlySpousalSupport"
                    control={control}
                    defaultValue=""
                    rules={{
                        validate: {
                            validRange: (value) => {
                                if (!value || value === '') return true;
                                const numValue = parseFloat(parseCurrency(value));
                                if (isNaN(numValue)) return 'Must be a valid number';
                                if (numValue < 0) return 'Must be greater than or equal to 0';
                                if (numValue > 999999) return 'Must be less than or equal to 999,999';
                                return true;
                            }
                        }
                    }}
                    render={({ field: { onChange, value, ...field } }) => (
                        <TextField
                            {...field}
                            label="Amount of Spousal Support Needed"
                            type="text"
                            value={formatCurrency(value)}
                            onChange={(e) => {
                                const formatted = formatCurrency(e.target.value);
                                onChange(parseCurrency(formatted));
                            }}
                            error={!!errors.monthlySpousalSupport}
                            helperText={errors.monthlySpousalSupport?.message}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            }}
                            fullWidth
                        />
                    )}
                />

                <Controller
                    name="monthlyChildSupport"
                    control={control}
                    defaultValue=""
                    rules={{
                        validate: {
                            validRange: (value) => {
                                if (!value || value === '') return true;
                                const numValue = parseFloat(parseCurrency(value));
                                if (isNaN(numValue)) return 'Must be a valid number';
                                if (numValue < 0) return 'Must be greater than or equal to 0';
                                if (numValue > 999999) return 'Must be less than or equal to 999,999';
                                return true;
                            }
                        }
                    }}
                    render={({ field: { onChange, value, ...field } }) => (
                        <TextField
                            {...field}
                            label="Amount of Child Support Indicated by Child Support Guidelines"
                            type="text"
                            value={formatCurrency(value)}
                            onChange={(e) => {
                                const formatted = formatCurrency(e.target.value);
                                onChange(parseCurrency(formatted));
                            }}
                            error={!!errors.monthlyChildSupport}
                            helperText={errors.monthlyChildSupport?.message}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            }}
                            fullWidth
                        />
                    )}
                />
            </Box>
        </Box>
    );
};

export default FinancialInfoSection;